export default __webpack_public_path__ + "static/media/svyaznoy.bed59034.svg";